import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Truck, Clock, Star } from 'lucide-react';
import './ServiceCoverage.css';

const ServiceCoverage = () => {
  const coverageAreas = [
    { city: 'London', deliveries: '2,500+', icon: <MapPin size={40} /> },
    { city: 'Manchester', deliveries: '1,800+', icon: <Truck size={40} /> },
    { city: 'Glasgow', deliveries: '1,200+', icon: <Clock size={40} /> },
    { city: 'Birmingham', deliveries: '2,000+', icon: <Star size={40} /> },
  ];

  const testimonials = [
    {
      name: 'Sarah Thompson',
      role: 'Supply Chain Manager',
      quote: 'CVJ’s reliable delivery network keeps our operations seamless.',
      rating: 5,
    },
    {
      name: 'Liam Carter',
      role: 'Retail Distributor',
      quote: 'Fast, safe haulage for our oversized stock—highly recommend!',
      rating: 4,
    },
    {
      name: 'Aisha Patel',
      role: 'Warehouse Owner',
      quote: 'Their refrigerated vans saved our perishable goods every time.',
      rating: 5,
    },
  ];

  const coverageVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: (i) => ({
      opacity: 1,
      scale: 1,
      transition: { duration: 0.6, delay: i * 0.2, ease: 'easeOut' },
    }),
    hover: { scale: 1.05 },
  };

  const testimonialVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, delay: i * 0.2, ease: 'easeOut' },
    }),
  };

  return (
    <section id="coverage" className="service-coverage">
      <div className="coverage-map-bg" />
      <motion.h2
        className="coverage-title"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        Service Coverage
      </motion.h2>
      <div className="coverage-grid">
        {coverageAreas.map((area, index) => (
          <motion.div
            key={index}
            className="coverage-card"
            custom={index}
            variants={coverageVariants}
            initial="hidden"
            whileInView="visible"
            whileHover="hover"
            viewport={{ once: true }}
          >
            <div className="coverage-icon">{area.icon}</div>
            <h3 className="coverage-city">{area.city}</h3>
            <p className="coverage-deliveries">{area.deliveries} Deliveries</p>
          </motion.div>
        ))}
      </div>
      <div className="coverage-stats">
        <motion.div
          className="stat-item"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <span className="stat-value">50+</span>
          <span className="stat-label">Cities Covered</span>
        </motion.div>
        <motion.div
          className="stat-item"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <span className="stat-value">24/7</span>
          <span className="stat-label">Availability</span>
        </motion.div>
      </div>
      <div className="testimonial-grid">
        {testimonials.map((testimonial, index) => (
          <motion.div
            key={index}
            className="testimonial-card"
            custom={index}
            variants={testimonialVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <p className="testimonial-quote">“{testimonial.quote}”</p>
            <div className="testimonial-info">
              <h3 className="testimonial-name">{testimonial.name}</h3>
              <span className="testimonial-role">{testimonial.role}</span>
              <div className="testimonial-rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={16} fill="#FF007A" color="#FF007A" />
                ))}
              </div>
            </div>
          </motion.div>
        ))}
      </div>
      <motion.a
        href="#contact"
        className="coverage-cta"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4 }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        Contact Us
      </motion.a>
    </section>
  );
};

export default ServiceCoverage;